import { Button } from '@cuemath/web-comps';
import React from 'react';
import PropTypes from 'prop-types';

const PageButton = ({ onClick, isDisabled, label, isBusy }) => {
  return (
    <Button
      label={label}
      onClick={onClick}
      isDisabled={isDisabled}
      isBusy={isBusy}
      size="small"
    />
  );
};

PageButton.propTypes = {
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  isBusy: PropTypes.bool,
};

export default PageButton;
